import React from 'react'
import ConfigPageLayout from '../components/ConfigPageLayout'

export default function OllamaConfigPage() {
  return (
    <ConfigPageLayout title="OLLAMA" description="Configuration des modèles Ollama et endpoints">
      <div className="rounded-3xl border border-emerald-100/80 bg-white/90 p-8 shadow-xl shadow-emerald-500/10 dark:border-emerald-900/50 dark:bg-zinc-950/90">
        <div className="space-y-6">
          <div className="rounded-2xl border border-blue-200/70 bg-blue-50 p-6 dark:border-blue-900/60 dark:bg-blue-950/40">
            <div className="flex items-start gap-4">
              <svg className="h-6 w-6 flex-shrink-0 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <h3 className="font-semibold text-blue-900 dark:text-blue-100">Configuration Ollama</h3>
                <p className="mt-2 text-sm text-blue-700 dark:text-blue-200">
                  La configuration des modèles Ollama est accessible via la page Modèles. 
                  Vous pouvez y gérer les endpoints, les modèles disponibles et leurs paramètres.
                </p>
                <a
                  href="/models"
                  className="mt-4 inline-flex items-center gap-2 rounded-full border border-blue-200/70 bg-blue-100 px-4 py-2 text-sm font-medium text-blue-700 transition hover:bg-blue-200 dark:border-blue-900/60 dark:bg-blue-900/40 dark:text-blue-200 dark:hover:bg-blue-900/60"
                >
                  Accéder aux modèles
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-zinc-900 dark:text-white">Fonctionnalités disponibles</h3>
            <ul className="space-y-3 text-sm text-zinc-600 dark:text-zinc-400">
              <li className="flex items-start gap-3">
                <svg className="h-5 w-5 flex-shrink-0 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Configuration des endpoints Ollama (local ou cloud)</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="h-5 w-5 flex-shrink-0 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Gestion des modèles disponibles</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="h-5 w-5 flex-shrink-0 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Paramètres de température et tokens</span>
              </li>
              <li className="flex items-start gap-3">
                <svg className="h-5 w-5 flex-shrink-0 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Test de connexion aux endpoints</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ConfigPageLayout>
  )
}
